/**
 * User role constants.
 * Must stay in sync with backend UserRole enum in models.py.
 */
export const ROLES = {
  CAST: 'cast',
  DRIVER: 'driver',
  ADMIN: 'admin',
  SHOP_ADMIN: 'shop_admin',
  CORPORATE_ADMIN: 'corporate_admin',
  SUPER_ADMIN: 'super_admin',
};

/**
 * Role display labels (Japanese).
 */
export const ROLE_LABELS = {
  [ROLES.CAST]: 'キャスト',
  [ROLES.DRIVER]: 'ドライバー',
  [ROLES.ADMIN]: '管理者',
  [ROLES.SHOP_ADMIN]: '店舗管理者',
  [ROLES.CORPORATE_ADMIN]: '企業管理者',
  [ROLES.SUPER_ADMIN]: 'システム管理者',
};

/**
 * Check if role is an admin-level role (shop_admin, admin, corporate_admin).
 */
export function isAdminRole(role) {
  return [ROLES.ADMIN, ROLES.SHOP_ADMIN, ROLES.CORPORATE_ADMIN].includes(role);
}

/**
 * Check if role is a shop-level admin (shop_admin or admin).
 */
export function isShopAdmin(role) {
  return role === ROLES.SHOP_ADMIN || role === ROLES.ADMIN;
}
